function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_calendar_list_selected)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 1,
  fill: "#DCDCDC"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 4,
  width: 15,
  height: 32,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 13,
  height: 4,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 11,
  width: 13,
  height: 4,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 18,
  width: 13,
  height: 4,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 25,
  width: 13,
  height: 4,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 32,
  width: 13,
  height: 4,
  rx: 1,
  fill: "#F7F7F7"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_calendar_list_selected",
  x: 0,
  y: 0,
  width: 40,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})));

var SvgCalendarListSelected = function SvgCalendarListSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarListSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CalendarListSelected.c68ab658.svg";
export { ForwardRef as ReactComponent };